<template>
    <v-simple-table>
        <tr>
            <th>Nama</th>
            <th>Link</th>
            <th>URL</th>
        </tr>
        <tr
            v-for="(link, idx) in links"
            :key="idx"
        >
            <td>{{ link.title }}</td>
            <td>{{ link.link }}</td>
            <td>{{ link.url }}</td>
        </tr>
    </v-simple-table>
</template>

<script>
export default {
    data: () => ({
        links: null
    }),

    methods: {
        async update() {
            const response = await this.$apiv2.get('link', { loader: 'appbar' })
            this.links = response.data.links
        }
    },

    created() {
        this.update()
    }
}
</script>
